// @flow
import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import { MdClose, MdSearch } from 'react-icons/md';
import { type ContextRouter, withRouter } from 'react-router-dom';
import type { PostItem } from 'store/modules/listing';
import storage from 'lib/storage';
import { SearchActions } from 'store/actionCreators';
import type {State} from '../../../store';
import './SearchHistory.scss';
import Button from "../../common/Button";

type Props = {
  result: ?{
    count: number,
    data: PostItem[],
  },
  onSearchNext: () => any,
  menu: string,
  currentKeyword: string,
};

class SearchHistory extends Component<Props> {
  onDelete = (keyword) => {
    storage.splice('searchHistory', keyword);
    SearchActions.deleteSearchHistory(keyword);
  };

  onSearchAllDelete = () => {
    storage.set('searchHistory', []);
    SearchActions.removeSearchHistory();
  };

  onSearch = (keyword: string, menu: string) => {
    const { currentKeyword, currentMenu, history } = this.props;
    console.log('asdsad111');
    if (currentKeyword === keyword && currentMenu === menu) return null;
    if (!keyword) {
        // SearchActions.initialize();
        return null;
    }
    // SearchActions.initialize();
    const q = keyword
      .replace(/&/g,"%26")
      .replace(/\+/g,"%2B");
    history.push(`/search?q=${q}&menu=products`);
    return SearchActions.publicSearch({
      q,
      menu,
    });
  };

  renderSearchHistory() {
    const { searchHistory } = this.props;
    if (!searchHistory) return null;
    return (
      searchHistory.length ?
        searchHistory.map(keyword => (
          <li key={keyword} className="keyword">
            <Button
              className="word"
              theme="transparent"
              onClick={() => this.onSearch(keyword, 'products')}
            >
              {keyword}
            </Button>
            <Button
              className="delete"
              theme="outline"
              onClick={() => this.onDelete(keyword)}
            >
              <MdClose />
            </Button>
          </li>
        )) :
        <div className="empty">최근 검색 내역이 없습니다.</div>
    )
  }

  render() {
    return (
      <div className="SearchHistory">
        <div className="wrapper">
          <span className="title">
            최근 검색어
          </span>
          <Button
            className="all-delete"
            theme="outline"
            onClick={() => this.onSearchAllDelete()}
          >
            전체 삭제
          </Button>
        </div>
        {this.renderSearchHistory()}
      </div>
    );
  }
}

export default connect(
  (state: State) => ({
    searchHistory: state.search.searchHistory,
  }),
  () => ({}),
)(withRouter(SearchHistory));



// WEBPACK FOOTER //
// ./src/components/search/SearchHistory/SearchHistory.js